import { action } from 'typesafe-actions';
// eslint-disable-next-line no-unused-vars
import { LotsTypes, LotInterface } from './types';

// List Lots
export const listLotsRequest = (payload: {
  body?: object;
  filtering?: boolean;
}) => action(LotsTypes.LIST_LOTS_REQUEST, payload);
export const listLotsSuccess = (payload: {
  lotsList: LotInterface[];
  totalCount: number;
}) => action(LotsTypes.LIST_LOTS_SUCCESS, payload);
export const listLotsFailure = () => action(LotsTypes.LIST_LOTS_FAILURE);

// Get Lot
export const getLotRequest = (payload: object) =>
  action(LotsTypes.GET_LOT_REQUEST, payload);
export const getLotSuccess = (payload: { lotData: LotInterface }) =>
  action(LotsTypes.GET_LOT_SUCCESS, payload);
export const getLotFailure = () => action(LotsTypes.GET_LOT_FAILURE);

// Filter Lots
export const filterLotsRequest = (payload: object) =>
  action(LotsTypes.FILTER_LOTS_REQUEST, payload);
export const filterLotsSuccess = (payload: {
  lotsList: LotInterface[];
  totalCount: number;
}) => action(LotsTypes.FILTER_LOTS_SUCCESS, payload);
export const filterLotsFailure = () => action(LotsTypes.FILTER_LOTS_FAILURE);

// Create Lot
export const createLotRequest = (payload: object) =>
  action(LotsTypes.CREATE_LOT_REQUEST, payload);
export const createLotSuccess = (payload: { lotData: LotInterface }) =>
  action(LotsTypes.CREATE_LOT_SUCCESS, payload);
export const createLotFailure = () => action(LotsTypes.CREATE_LOT_FAILURE);

// Update Lot
export const updateLotRequest = (payload: object) =>
  action(LotsTypes.UPDATE_LOT_REQUEST, payload);
export const updateLotSuccess = (payload: { lotData: LotInterface }) =>
  action(LotsTypes.UPDATE_LOT_SUCCESS, payload);
export const updateLotFailure = () => action(LotsTypes.UPDATE_LOT_FAILURE);

// Delete Lot
export const deleteLotRequest = (payload: object) =>
  action(LotsTypes.DELETE_LOT_REQUEST, payload);
export const deleteLotSuccess = () => action(LotsTypes.DELETE_LOT_SUCCESS);
export const deleteLotFailure = () => action(LotsTypes.DELETE_LOT_FAILURE);
